import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description?: string;
  canonicalUrl?: string;
  ogImage?: string;
  jsonLd?: Record<string, any>;
  noindex?: boolean;
}

const SEO = ({ title, description, canonicalUrl, ogImage, jsonLd, noindex }: SEOProps) => {
  const siteUrl = 'https://wloska-piwnica.pl';
  
  // Format title: Ensure 'Włoska Piwnica' is capitalized properly
  const formattedTitle = title.replace(/włoska piwnica/i, 'Włoska Piwnica');
  const finalTitle = formattedTitle.includes('Włoska Piwnica') ? formattedTitle : `${formattedTitle} - Włoska Piwnica`;
  
  // Provide default OG Image if missing
  const finalOgImage = ogImage || '/og-image.jpg';
  
  // Safe URL constructor
  const getFullUrl = (path: string) => {
    if (path.startsWith('http')) return path;
    return `${siteUrl}${path.startsWith('/') ? path : `/${path}`}`;
  };

  return (
    <Helmet>
      <title>{finalTitle}</title>
      {description && <meta name="description" content={description} />}

      {noindex ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}

      {/* Open Graph */}
      <meta property="og:title" content={finalTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="pl_PL" />
      {canonicalUrl && <meta property="og:url" content={getFullUrl(canonicalUrl)} />}
      <meta property="og:image" content={getFullUrl(finalOgImage)} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={getFullUrl(finalOgImage)} />

      {/* Canonical */}
      {canonicalUrl && <link rel="canonical" href={getFullUrl(canonicalUrl)} />}

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
